export const pageView = pageObject => ({
  type: 'PAGE_VIEW',
  data: {
    eventName: 'Standard Page View',
    pageObject
  }
});

export const defaultClick = eventObject => ({
  type: 'DEFAULT_CLICK',
  data: {
    eventName: 'Default Page Click',
    eventObject
  }
});

export const detectAdBlocker = eventObject => ({
  type: 'DETECT_AD_BLOCKER',
  data: {
    eventName: 'Detect Ad Blocker',
    eventObject
  }
});

export const fireActionTriggerCustomEvent = (
  eventName,
  data,
  target = document.querySelector('body')
) => {
  const event = new CustomEvent(eventName, data);
  target.dispatchEvent(event);
};
